import React from 'react'
import { Icons } from '@pankod/refine-antd'
import { useCreate } from '@pankod/refine-core'

import { showErrorNotification } from '@resources/angkatan-ppg-management/utils'
import PeriodePenilaianDrawer, {
  usePeriodePenilaianDrawer,
} from '../../../../program-setup/blocks/periode-penilaian/PeriodePenilaianDrawer'
import MenuItemPopconfirm from '../../MenuItemPopconfirm'
import { Highlighter } from '../../utils'
import { StatusTag } from '../StatusTag'

import type {
  TConfigurationSection,
  TConfigurationSectionContext,
} from '../types'

export const useTimeTrackerConfiguration = ({
  invalidateProgramDetail,
  program,
  programId,
  runAndClose,
  search,
}: TConfigurationSectionContext): TConfigurationSection => {
  const { mutate: toggleTimeTracker, isLoading } = useCreate()
  const { show: showAssessmentPeriod, ...drawerProps } =
    usePeriodePenilaianDrawer()
  const active = program?.timeTrackerActive

  return {
    menuItems: [
      {
        type: 'group',
        label: (
          <div className="flex justify-between gap-2">
            <Highlighter search={search} text="Time Tracker" />
            <StatusTag
              active={!!active}
              activeText="AKTIF"
              inactiveText="NONAKTIF"
            />
          </div>
        ),
        key: 'Time Tracker',
        children: [
          {
            icon: isLoading ? (
              <Icons.LoadingOutlined spin />
            ) : active ? (
              <Icons.StopOutlined />
            ) : (
              <Icons.FieldTimeOutlined />
            ),
            key: active ? 'Nonaktifkan Time Tracker' : 'Aktifkan Time Tracker',
            danger: active,
            disabled: isLoading,
            label: (
              <MenuItemPopconfirm
                title={`Apakah Anda ingin ${
                  active ? 'me-nonaktifkan' : 'mengaktifkan'
                } time tracker?`}
                okText={active ? 'Nonaktifkan' : 'Aktifkan'}
                cancelText="Batal"
                disabled={isLoading}
                okButtonProps={{ danger: active }}
                onConfirm={() =>
                  toggleTimeTracker(
                    {
                      resource: `programs/${programId}/time-tracker`,
                      dataProviderName: 'lms',
                      values: { active: !active },
                      successNotification: {
                        message: 'Time Tracker berhasil dikonfigurasi ulang',
                        type: 'success',
                        description: 'Sukses',
                      },
                      errorNotification: (error) =>
                        showErrorNotification(
                          error,
                          'Terdapat gangguan saat mengubah konfigurasi time tracker',
                        ),
                    },
                    { onSuccess: invalidateProgramDetail },
                  )
                }
              >
                <Highlighter
                  search={search}
                  text={
                    active
                      ? 'Nonaktifkan Time Tracker'
                      : 'Aktifkan Time Tracker'
                  }
                />
              </MenuItemPopconfirm>
            ),
          },
          {
            key: 'Periode Penilaian',
            type: 'group',
            label: <Highlighter search={search} text="Periode Penilaian" />,
            children: [
              {
                key: 'Kelola Periode',
                label: <Highlighter search={search} text="Kelola Periode" />,
                icon: <Icons.ClockCircleOutlined />,
                onClick: () =>
                  runAndClose(() =>
                    showAssessmentPeriod(programId, program?.name!),
                  ),
              },
            ],
          },
        ],
      },
    ],
    overlays: <PeriodePenilaianDrawer {...drawerProps} />,
  }
}
